<template>
  <div id="table">
    <table class="table" cellpadding="0" cellspacing="0">
      <tr>
        <td class="text-center">วันที่</td>
        <td>
          <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="lotto.lotto_date" placeholder="เลือกวันที่" :disabled="!isNew" />
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาเริ่มหมุน</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.start_spin" placeholder="เวลาเริ่มหมุน" :disabled="!isNew" />
          <div v-if="invalidStartSpin" class="text-danger text-sm">กรุณาใส่เวลาเริ่มหมุน</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาแสดงผล</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.show_result" placeholder="เวลาแสดงผล" :disabled="!isNew" />
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 5 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="digit5" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 5 ตัว" maxlength="5" v-model="lotto.results.digit5">
          <div class="text-danger text-sm">{{ errors.first('digit5') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 4 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="digit4" v-validate="'numeric|length:4'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 4 ตัว" maxlength="4" v-model="lotto.results.digit4" disabled>
          <div class="text-danger text-sm">{{ errors.first('digit4') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 3 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="digit3" v-validate="'numeric|length:3'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 3 ตัว" maxlength="3" v-model="lotto.results.digit3" disabled>
          <div class="text-danger text-sm">{{ errors.first('digit3') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 2 ตัวบน</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="digit2_top" v-validate="'numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 2 ตัว" maxlength="2" v-model="lotto.results.digit2_top" disabled>
          <div class="text-danger text-sm">{{ errors.first('digit2_top') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 2 ตัวล่าง</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="digit2_bottom" v-validate="'numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 2 ตัว" maxlength="2" v-model="lotto.results.digit2_bottom" disabled>
          <div class="text-danger text-sm">{{ errors.first('digit2_bottom') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="text-center">
          <vs-button :disabled="isLoading" class="vs-xs-12" color="success" @click="save">บันทึก</vs-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "moment"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'ResultForm',
  components: {
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    isNew: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lotto: this.data,
      invalidStartSpin: false
    }
  },
  computed: {
    minShow1st() {
      if (this.lotto.show_2nd)
        return moment(this.lotto.show_2nd).add(15, 'minute').format("YYYY-MM-DD HH:mm:ss")
      else
        return ''
    }
  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$emit('save', this.lotto)
        }
      })
    }
  }
}

</script>
<style lang="scss">
#table {
  .table {
    width: auto;
    background-color: #FFF;
    border-collapse: collapse;
  }

  .table {
    tr {
      td {
        &:first-child {
          width: 200px;
          font-weight: bold;
        }

        .vs-input--input {
          width: auto;
        }

        input {
          border: 1px solid rgba(0, 0, 0, 0.2);
          color: blue;
        }

        .vdp-datepicker input {
          width: auto;
        }
      }

      td {
        padding: 16px 8px;
        border: 1px solid #DDDDDD;
        border-collapse: collapse;
      }

      .no-boder-r {
        border-right: 0;
      }

      .no-boder-l {
        border-left: 0;
      }

      .no-boder-t {
        border-top: 0;
      }

      .no-boder-b {
        border-bottom: 0;
      }
    }
  }

  .text-center {
    text-align: center;
  }
}

</style>
